module.exports = __webpack_public_path__ + "img/avatar_44.288cbb70.svg";